/*
deviceModel.js
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

import { getDeviceInfo } from "../xerox/eipClient/deviceConfig"
import { xrxGetElementValue, xrxStringToDom } from "../xerox/modular-xerox-js-library/xrxjslib.module"
import { BrowserTypeEnum } from "../types/browserTypeEnum"

const modelFieldPath = "DeviceInformation > device > model"
const serialFieldPath = "DeviceInformation > device > serial"

export const getDeviceInfoValues = () => getDeviceInfo().then(r => ({
    serial: getDeviceInfoPathField(r, serialFieldPath),
    model: getDeviceInfoPathField(r, modelFieldPath)
}))

const getDeviceInfoPathField = (deviceInfoString, fieldPath) => $(getDeviceInfoField(getDeviceInformationFieldString(deviceInfoString))).find(fieldPath).text()

const getDeviceInformationFieldString = deviceInfoString => xrxGetElementValue(xrxStringToDom(deviceInfoString), "Information")
const getDeviceInfoField = deviceInformationFieldString => xrxStringToDom(deviceInformationFieldString)

export const getBrowserType = () =>{
	let browserType = 0;
    let uaString = navigator.userAgent || "";
	uaString = uaString.toLowerCase();
	if (uaString.indexOf( "galio" ) >= 0) {
		browserType = BrowserTypeEnum.Galio;
	} 
	else if (uaString.indexOf( "webkit" ) >= 0) {
		if (uaString.indexOf( "x2g" ) >= 0) {
			browserType = BrowserTypeEnum.SecondGen;
		}  
		else if (uaString.indexOf( "x3g" ) >= 0) {
			browserType = BrowserTypeEnum.ThirdGen;
		}
	}
	return browserType;
}
